import { PUBLIC_RUNTIME_CONFIG } from '../config/constants';

export default function backendUrl(url: string) {
  return `${PUBLIC_RUNTIME_CONFIG.BACKEND_URL}${url}`;
}
